"use client";
import React from "react";
import PropTypes from "prop-types";
import { styles } from "./element";
import { Header } from "semantic-ui-react";

const Title = ({ name, colorClass, ...props }) => {
  return (
    <Header
      content={name}
      style={colorClass ? styles.black : styles.normal}
      {...props}
    />
  );
};

Title.propTypes = {
  name: PropTypes.string,
};

export default Title;
